import { Component } from '@angular/core';
import { MunilyPanelData } from 'src/app/common-components/panel/panel.types';

@Component({
  selector: 'app-panel-playground',
  templateUrl: './panel-playground.component.html',
  styleUrls: ['./panel-playground.component.scss'],
})
export class PanelPlaygroundComponent {
  title = 'Permitir reservas día completo';
  description = 'Configura la disponibilidad para permitir reservas de día completo.';
  subtitle = 'No';
  showSubtitle = true;
  showDescription = true;
  showChevron = true;
  showFooter = true;
  /** `false` = lista sin borde (elevación al hover). */
  showPanelBorder = true;
  lastEvent = '';

  readonly simpleData: MunilyPanelData = {
    title: 'Área amerita aprobación',
    subtitle: 'No',
    showSubtitle: true,
    showChevron: true,
    showFooter: false,
  };

  readonly detailedData: MunilyPanelData = {
    title: 'Permitir reservas día completo',
    description: 'Configura la disponibilidad para permitir reservas de día completo.',
    showDescription: true,
    subtitle: 'No',
    showSubtitle: true,
    showChevron: true,
    showFooter: true,
    descriptions: [
      { text: 'Tiempo mínimo de reserva: 15 mins', visible: true },
      { text: 'Tiempo máximo de reserva: 2 bloques (30 minutos)', visible: true },
    ],
  };

  get dynamicData(): MunilyPanelData {
    return {
      title: this.title,
      description: this.description,
      showDescription: this.showDescription,
      subtitle: this.subtitle,
      showSubtitle: this.showSubtitle,
      showChevron: this.showChevron,
      showFooter: this.showFooter,
      bordered: this.showPanelBorder,
      descriptions: [
        { text: 'Tiempo mínimo de reserva: 15 mins', visible: true },
        { text: 'Tiempo máximo de reserva: 2 bloques (30 minutos)', visible: true },
      ],
    };
  }

  onSelect(label: string): void {
    this.lastEvent = `select (${label}) @ ${new Date().toLocaleTimeString()}`;
  }
}
